
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 104 99"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52 13.5a36 36 0 1036 36 36 36 0 00-36-36zM52 81a31.5 31.5 0 1131.5-31.5A31.53 31.53 0 0152 81zm-.49-15.74h4.16V60h-4.16zM59.79 34a10.36 10.36 0 00-3.37-1.91 13.11 13.11 0 00-8.69.23A10.71 10.71 0 0044 34.81a10.25 10.25 0 00-2.33 3.86 14.23 14.23 0 00-.67 4.66h4.5a10 10 0 01.48-3.2 5.9 5.9 0 011.31-2.19 6.12 6.12 0 012.15-1.42 8.58 8.58 0 015.56-.14 5.72 5.72 0 011.89 1.06 4.81 4.81 0 011.23 1.63 5.81 5.81 0 01-.25 4.93 14.05 14.05 0 01-2.24 2.67c-.82.83-1.48 1.47-2 1.94a8.08 8.08 0 00-1.58 2 7.38 7.38 0 00-.69 2.39c-.09.72-.15 1.74-.18 3.09l4.5.1c0-1.16.07-2 .14-2.64a2.56 2.56 0 01.24-.91 3.32 3.32 0 01.69-.84c.51-.49 1.2-1.16 2-2a18.4 18.4 0 002.91-3.5A9.35 9.35 0 0063 41.29a9.56 9.56 0 00-.87-4.14A9.31 9.31 0 0059.79 34z"}})])
          )
        }
      }
    